import type { RootState } from '../../../stores/store';

export const deviceDataSelector = (state: RootState) => state.deviceInfo;
export const sensorSourceSelector = (state: RootState) => state.deviceInfo.sensorSource;
export const insectListSelector = (state: RootState) => state.insectsList;
